// import axios from 'axios'
import axios from '../../helpers/Axios'

export const regionmodule = {

	namespaced: true,

	state: {

		allRegions: []
	},
	getters: {

		allRegions: state => { return state.allRegions; }
	},
	actions: {

		getRegions({ commit }) {
			return axios.get('/region').then(response => {

				commit('allRegions', response.data);

			}).catch(err => {
				console.log(err);
			});
		}
	},
	mutations: {

		allRegions(state, regions) {
			state.allRegions = regions
		}
	}
}
